import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import Icon from '@mdi/react'
import { mdiCheckCircleOutline, mdiCloseCircleOutline } from '@mdi/js'

const useStyles = makeStyles(theme => ({
    statusContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.borderRadius,
        fontSize: 14,
        padding: 4,
        paddingLeft: 0
    },
    online: {
        marginRight: 45,
        marginLeft: 5
    },
    offline: {
        marginLeft: 5,
        width: 87
    }
}))

export function NetworkDeviceStatus({ value }) {
    const classes = useStyles()
    const { theme, locale } = useSelector(state => state.main)
    if (!value) {
        return 'N/A'
    }

    const isOnline = value === 'connected'
    const statusText = isOnline
        ? locale.common.online
        : locale.common.disconnected
    const statusClass = isOnline ? classes.online : classes.offline
    const statusIcon = isOnline ? (
        <Icon path={mdiCheckCircleOutline} size={1} color={theme.active} />
    ) : (
        <Icon path={mdiCloseCircleOutline} size={1} color={theme.error} />
    )

    return (
        <div className={classes.statusContainer}>
            {statusIcon}
            <span className={statusClass}>{statusText}</span>
        </div>
    )
}
